import { css } from 'linaria';

export const interiorDoorsTrendsTextWrapper = css`
  width: 696px;
  margin-bottom: 24px;

  @media (--obly-desktop) {
    width: 536px;
  }

  @media (--to-desktop) {
    width: 100%;
  }
`;

export const interiorDoorsTrendsTitle = css`
  @media (--only-mobile) {
    margin-bottom: 12px;
  }
`;

export const interiorDoorsMediaCarBody = css`
  && {
    height: 100%;
  }
`;

export const interiorDoorsMediaCardDescription = css`
  white-space: break-spaces;

  @media (--from-desktop) {
    margin-bottom: 32px;
  }
`;

export const interiorDoorsModalMediaCardImage = css`
  && {
    height: 100%;
  }
`;
